import { Component, ViewChild } from "@angular/core";
import { Section } from "../../draggable/types";
import { ComponentStore, tapResponse } from "@ngrx/component-store";
import { ValuationReportTemplateFormComponent } from "../valuation-report-template-form/valuation-report-template-form.component";
import { MatDialogRef } from "@angular/material/dialog";
import { ValuationReportTemplateService } from "../valuation-report-template.service";
import { defaultSections } from "../default-structure";
import { switchMap, withLatestFrom } from "rxjs/operators";
import { of } from "rxjs";

interface State {
  sections: Section[],
  updatedSections: Section[]
}

@Component({
  selector: 'kt-valuation-report-template-edit-modal',
  templateUrl: './valuation-report-template-edit-modal.component.html',
  providers: [ComponentStore]
})
export class ValuationReportTemplateEditModalComponent {
  @ViewChild(ValuationReportTemplateFormComponent) formComponent: ValuationReportTemplateFormComponent 
  sections$ = this.componentStore.select(state => state.sections)
  constructor(
    private dialogRef: MatDialogRef<ValuationReportTemplateEditModalComponent>,
    private componentStore: ComponentStore<State>,
    private service: ValuationReportTemplateService
  ) {
    this.componentStore.setState({
      sections: defaultSections,
      updatedSections: defaultSections
    })
  }

  onClose() {
    this.dialogRef.close()
  }
  onSectionsChanged(sections: Section[]) {
    this.componentStore.patchState({updatedSections: sections})
  }
  onSubmit() {
    this.submit()
  }
  private readonly submit = this.componentStore.effect<void>(trigger$ => 
    trigger$.pipe(
      withLatestFrom(this.componentStore.state$),
      switchMap(([_, state]: [void, State]) => {
        if (!this.formComponent) return of();
        const validation = this.formComponent.validate()
        if (validation === 'invalid') return of();
        const payload = this.formComponent.preparePayload(state.updatedSections)
        return this.service.create(payload).pipe(
          tapResponse(
            (res) => {
              this.dialogRef.close(res.data)
            },
            (err) => console.error(err)
          )
        )
      })
    )
  )
}